// ComingSoon.js
import React from "react";

const ComingSoon = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-black">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-red-500 mb-4">Coming Soon</h2>
        <p className="text-gray-400">
          This feature is currently under development.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
